<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Customer</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Vehicles</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3">Select Products</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 4" step="4">Assign Products</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 5" step="5">Finance</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 6" step="6">Contact</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="pt-5">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete v-model="customer" :items="customerList" :loading="gettingCustomers" label="Select a Customer" item-text="name"
                    hide-details item-value="key">
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 class="text-xs-center pb-2 pt-3">
                  <h3>OR</h3>
                </v-flex>
                <v-flex xs12>
                  <v-btn block color="primary" @click="$router.push('/Admin/Customer')">Add New Customer</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step2" :disabled="!customer" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn color="primary" @click="addVehicleDialog = true">Add Vehicle</v-btn>
                  <multi-vehicle-dialog @vehiclesAdded="vehiclesAdded" :parentCustomer="customer" :customerFixed="true"></multi-vehicle-dialog>
                  <bulk-add-vehicle-dialog @vehiclesAdded="vehiclesAdded" :parentCustomer="customer" :customerFixed="true"></bulk-add-vehicle-dialog>
                  <v-btn @click="selectNew" outline color="primary">Select All New Vehicles</v-btn>
                  <v-btn style="float:right;" color="primary" @click="step3" :disabled="vehicles.length === 0" depressed>Next</v-btn>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="searchVehicles" append-icon="search"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-data-table :items="vehicleList" hide-actions :loading="gettingVehicles" v-model="vehicles" :search="searchVehicles" item-key="id"
                    select-all :headers="[{text:'Row', value: 'index', sortable: false},{text:'Vehicle ID.', value: 'friendlyId', sortable: true},{text:'Vehicle Reg.', value: 'VehicleReg', sortable: true},{text:'Make.', value: 'Make', sortable: true}, {text:'Model.', value: 'Model', sortable: true}, {text:'Year Reg.', value: 'Year', sortable: true}, {text:'Added', value: 'Added', sortable: true}, {text:'Actions', value: 'actions', sortable: false, align: 'right'}]" :pagination.sync="vehiclePagination">
                    <template slot="items" slot-scope="props">
                      <tr @click="props.selected = !props.selected">
                        <td>
                          <v-checkbox primary hide-details :value="props.selected"></v-checkbox>
                        </td>
                        <td>{{props.index + 1}}</td>
                        <td>{{props.item.friendlyId ? props.item.friendlyId : 'TBC' }}</td>
                        <td :style="props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;'">{{ props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC' }}</td>
                        <td>{{props.item.Make}}</td>
                        <td>{{props.item.Model}}</td>
                        <td>{{props.item.Year}}</td>
                        <td>{{props.item.Added|formatDate}}<v-chip v-if="props.item.New == true" color="green" text-color="white" small>New</v-chip></td>
                        <td class="text-xs-right">
                          <v-btn icon class="mx-0" @click.stop="deleteVehicle(props.item)">
                            <v-icon color="pink">delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Your search for "{{ searchVehicles }}" found no results.
                    </v-alert>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step1" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step3" :disabled="vehicles.length === 0" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step4" :disabled="selectedTemplates.length === 0" depressed>Next</v-btn>
                <v-flex xs12>
                  <h3 class="title">Products to Install</h3>
                  <v-treeview
                    :items="productsTreeView"
                    multiple-active
                    activatable
                    active-class="primary--text font-weight-black"
                    open-on-click
                    :active.sync="checkedTemplates"
                  >
                    <template v-slot:prepend="{ item, open, active }">
                        <v-icon v-if="!item.child">
                          {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                        <v-icon v-else-if="active">mdi-check</v-icon>
                    </template>
                  </v-treeview>
                  <!-- <v-list>
                    <v-list-tile v-for="template in templates" :key="template.id" action>
                      <v-list-tile-action>
                        <v-checkbox v-model="template.checked" :label="template.name"></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list> -->
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step2" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step4" :disabled="selectedTemplates.length === 0" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step5" depressed>Next</v-btn>
              </v-layout>
              <v-data-table :items="newVehicleData" hide-actions :loading="gettingVehicleData" :search="searchVehicleData" item-key="id"
                :pagination.sync="pagination" :headers="vehicleDataHeaders">
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th style="position: sticky; top:0; background:white; z-index:99;" v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : '']"
                      @click="changeSort(header.value)" :style="header.align ? 'text-align:' + header.align : ''">
                      <v-icon small>arrow_upward</v-icon>
                      <span>{{ header.text }}</span>
                    </th>
                  </tr>
                  <tr>
                    <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : '']" :style="header.align ? 'text-align:' + header.align : ''">
                      <v-btn v-if="header.class && header.class.indexOf('group-header') !== -1 && header.hasExtras" small icon :flat="header.class && header.class.indexOf('show') === -1"
                        color="primary" @click="toggleGroup(header.value)">
                        <v-icon class="group-hide-icon" :color="header.class && header.class.indexOf('show') === -1 ? 'primary' : 'white'">add</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr v-if="props.index === 0">
                    <td></td>
                    <template v-for="(template, index) in selectedTemplates">
                      <td :key="'checkAll-' + index" class="text-xs-center">
                        <v-checkbox hide-details v-model="allItemsInstalledDevices[template.id]" @change="changeInstalledDeviceAll(template.id)"
                          class="text-xs-center"></v-checkbox>
                      </td>
                      <template v-for="(templateExtra, extraIndex) in template.extras">
                        <td :class="(!allItemsInstalledDevices[template.id] ? 'grey lighten-2 ' : '' ) + 'col-' + template.id" v-show="template.visible" v-if="templateExtra.permissions.sales === 'write'" :key="'x-' + index + '-' + extraIndex">
                          <v-edit-dialog :return-value.sync="allItems[template.id][templateExtra.name]" v-if="allItemsInstalledDevices[template.id] && templateExtra.permissions.sales === 'write'" @save="changeExtraAll(template.id, templateExtra.name)" large lazy persistent>
                            <div>{{ allItems[template.id][templateExtra.name] }}</div>
                            <v-select slot="input" autofocus single-line v-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice'" :label="selectedTemplates[index]['extras'][extraIndex]['name']" :items="selectedTemplates[index]['extras'][extraIndex]['options']" v-model="allItems[template.id][templateExtra.name]" :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :clearable="selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false">
                            </v-select>
                            <v-text-field slot="input" autofocus single-line type="text" v-else-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'text'"
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="allItems[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true">
                            </v-text-field>
                            <v-text-field slot="input" autofocus single-line type="number" :step="selectedTemplates[index]['extras'][extraIndex]['step']" v-else
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="allItems[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true">
                            </v-text-field>
                          </v-edit-dialog>
                          <template v-else>{{ allItems[template.id][templateExtra.name] }}</template>
                        </td>
                      </template>
                    </template>
                  </tr>
                  <tr>
                    <td @click="updateVehicleRegDialog(props.item.id)" :style="['cursor:pointer;', props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;']">{{ props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'}}</td>
                    <template v-for="(template, index) in selectedTemplates">
                      <td :key="props.item.id + '-' + index" class="text-xs-center">
                        <v-checkbox hide-details v-model="props.item.installedDevices[template.id]" @change="changeInstalledDevice(props.item.id, template.id)"
                          class="text-xs-center"></v-checkbox>
                      </td>
                      <template v-for="(templateExtra, extraIndex) in template.extras">
                        <td style="border: solid 1px #eee!important;" :class="(props.item.installedDevices[template.id] && props.item.devices[template.id] && props.item.devices[template.id][templateExtra.name] === '' ? 'blue lighten-4 ' : '') + (!props.item.installedDevices[template.id] ? 'grey lighten-2 ' : '' ) + 'col-' + template.id" v-show="template.visible" v-if="templateExtra.permissions.sales === 'write'" :key="props.item.id + '-' + index + '-' + extraIndex">
                          <v-edit-dialog :return-value.sync="props.item.devices[template.id][templateExtra.name]" v-if="props.item.devices[template.id] && templateExtra.permissions.sales === 'write'"
                            large lazy persistent @open="openEditDialog(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))" @save="nextRow(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))" :ref="'edit-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            <div>{{ props.item.devices[template.id][templateExtra.name] }}</div>
                            <v-select slot="input" autofocus single-line v-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice'" :label="selectedTemplates[index]['extras'][extraIndex]['name']"
                              :items="selectedTemplates[index]['extras'][extraIndex]['options']" v-model="props.item.devices[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :clearable="selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false"
                               :ref="'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            </v-select>
                            <v-text-field slot="input" autofocus single-line type="text" v-else-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'text'"
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="props.item.devices[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :ref="'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            </v-text-field>
                            <v-text-field slot="input" autofocus single-line type="number" :step="selectedTemplates[index]['extras'][extraIndex]['step']" v-else
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="props.item.devices[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :ref="'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            </v-text-field>

                          </v-edit-dialog>
                          <template v-else>{{ props.item.devices[template.id] ? props.item.devices[template.id][templateExtra.name] : '' }}</template>
                        </td>
                      </template>
                    </template>
                  </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Your search for "{{ searchVehicleData }}" found no results.
                </v-alert>
              </v-data-table>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step3" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step5" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>
            
            <v-stepper-content step="5">
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step6" depressed>Next</v-btn>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3 class="title">Finance</h3>
                  <div v-for="template in selectedTemplates" :key="template.id" class="my-3">
                    <h4>{{template.name}}</h4>
                    <v-select multiple :items="paymentMethods" chips label="Payment Method(s)" v-model="finance[template.id]['paymentMethods']"></v-select>
                    <v-select label="Contact Term" :items="contractTerms" v-model="finance[template.id]['contractTerm']"></v-select>
                    <v-select label="Currency" :items="currencies" v-model="finance[template.id]['currency']"></v-select>
                    <v-text-field label="Upfront Payment Per Unit" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('upfront-payment')" v-model="finance[template.id]['upfrontPayment']"></v-text-field>
                    <v-text-field label="Installation Payment Per Unit" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('upfront-installation')" v-model="finance[template.id]['installationPayment']"></v-text-field>
                    <v-text-field label="Rental Payment Per Unit" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('rental')" v-model="finance[template.id]['rentalPayment']"></v-text-field>
                    <v-select label="Rental Frequency" :items="rentalFrequencies" v-if="finance[template.id]['paymentMethods'].includes('rental')" v-model="finance[template.id]['rentalFrequency']"></v-select>
                    <v-select label="lessor" :items="lessors" v-if="finance[template.id]['paymentMethods'].includes('lease')" v-model="finance[template.id]['lessor']"></v-select>
                    <v-text-field label="Lease Payment Per Unit" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('lease')" v-model="finance[template.id]['leasePayment']"></v-text-field>
                    <v-select label="Lease Frequency" :items="leaseFrequencies" v-if="finance[template.id]['paymentMethods'].includes('lease')" v-model="finance[template.id]['leaseFrequency']"></v-select>
                    <v-select label="Warranty" :items="warranties" v-model="finance[template.id]['warranty']"></v-select>
                    <v-select label="Warranty Type" :items="warrantyType" v-model="finance[template.id]['warrantyType']" v-if="finance[template.id]['warranty'] !== 'n/a'"></v-select>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step4Back" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step6" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>
            
            <v-stepper-content step="6">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap class="mt-3">
                    <h3 class="title">Contact</h3>
                    <v-spacer></v-spacer>
                    <v-btn @click="contactDialog = true" color="primary">Add Contact</v-btn>
                  </v-layout>
                  <v-autocomplete 
                    :items="contacts"
                    v-model="selectedContacts"
                    multiple
                    chips
                    deletable-chips
                    item-text="Name"
                    item-value="id"
                    label="Relevant Contacts"
                    hint="Please select any contacts that are relevant to this project.">
                    <template v-slot:item="data">
                      <template>
                        <v-list-tile-content>
                          <v-list-tile-title>{{data.item.Name}}<template v-for="site in data.item.Site"><v-chip label small class="pb-1" :key="site" v-if="sites[site]">{{sites[site].Name}}</v-chip></template></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step = 5" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveCtnSheetDialog" depressed :disabled="attachedDocs.length < 2 || qnq.length < 1 || selectedContacts.length < 1">Submit</v-btn>
              </v-layout>
            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>

        <v-card>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md8>
                <v-card-title>
                  <h3 class="title">Attached Documents</h3>
                  <upload-btn :title="'Attach New Document'" :fileChangedCallback="attachFile">
                    <template slot="icon">
                      <v-icon color="white">mdi-paperclip</v-icon>
                    </template>
                  </upload-btn>
                  <v-chip label outline color="red" v-if="attachedDocs.length < 2">{{(2 - attachedDocs.length) + ' doc'}}{{attachedDocs.length == 0 ? 's' : ''}}{{' required (GP sheet & SIGNED order form)'}}</v-chip>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-tile v-for="(fileObj, key) in attachedDocs" :key="fileObj.file.name" two-line>
                      <v-list-tile-action>
                        <v-btn icon color="error" @click="attachedDocs.splice(key, 1)" :disabled="savingCtnSheet">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="body-2">{{fileObj.file.name}}</span>
                          <span class="caption ml-1">{{fileObj.file.size | formatBytes}}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <v-progress-linear
                            :value="fileObj.Progress"
                            :color="fileObj.State === 0 ? 'primary' : fileObj.State === 1 ? 'blue' : fileObj.State === 2 ? 'warning' : fileObj.State === 3 ? 'success' : fileObj.State === 4 ? 'error' : 'primary'"></v-progress-linear>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-flex>
              <v-flex md4>
                <v-text-field :error-messages="qnq.length < 1 ? 'QNQ number is required' : ''" v-model="qnq" :error="qnq.length < 1" outline label="QNQ Number"></v-text-field>
                <v-text-field v-model="customerPO" outline label="Customer PO"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-dialog v-model="ctnSheetDialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Submit Order</v-card-title>
            <v-card-text>
              <v-textarea
                label="Order Note"
                :value="ctnSheetNote" 
                @change="v => ctnSheetNote = v"
                rows="3"
                auto-grow></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" flat @click.native="saveCtnSheet" :loading="savingCtnSheet">Submit</v-btn>
              <v-btn color="grey" flat @click.native="ctnSheetDialog = false" :disabled="savingCtnSheet">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="submittedDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Connection Sheet Submitted</v-card-title>
            <v-card-text>The connection sheet has been submitted for approval by support. Reference No: {{submittedRef}}.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click.native="reset">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      
      <v-dialog max-width="350" v-model="vehicleRegDialog">
        <v-card>
          <v-card-title class="headline">Update Vehicle Registration</v-card-title>
          <v-card-text>
            <v-text-field v-model="vehicleRegDialogData.Reg" label="Vehicle Reg." @keyup.enter="saveVehicleReg" autofocus ref="updateVehicleRegInput"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="saveVehicleReg" color="success" flat>Save</v-btn>
            <v-btn @click="vehicleRegDialog = false" color="grey" flat>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <new-vehicle-dialog @vehicleAdded="newVehicleAdded" :dialog.sync="addVehicleDialog" :customer="customer"></new-vehicle-dialog>
        <contact-edit-dialog @getContacts="step6" :contactID="null" :customer="customer" :customers="customerObj" :contactDialog.sync="contactDialog"></contact-edit-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { updateAuditLog, fireStore, storage, sendEmail } from '../firebase'
import moment from 'moment'
import UploadButton from 'vuetify-upload-button'
export default {
  components: {
    'upload-btn': UploadButton
  },
  beforeRouteLeave (to, from, next) {
    const answer = window.confirm('Do you really want to leave?  Any changes will be lost!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  data () {
    return {
      username: this.$store.getters.userData.Name,
      step: 1,
      vehiclePagination: {
        sortBy: 'friendlyId',
        descending: true,
        rowsPerPage: -1
      },
      pagination: {
        sortBy: 'VehicleReg',
        rowsPerPage: -1
      },
      templates: [],
      allItems: {},
      allItemsInstalledDevices: {},
      checkedTemplates: [],
      searchVehicles: '',
      searchVehicleData: '',
      contacts: [],
      contactDialog: false,
      customer: null,
      customerObj: {},
      customerShortName: null,
      vehicles: [],
      existingVehicleData: [],
      newVehicleData: [],
      gettingCustomers: false,
      gettingVehicles: false,
      gettingVehicleData: false,
      vehicleList: [],
      addCustomerDialog: false,
      templateDefaults: {},
      selectedContacts: [],
      submittedRef: null,
      sites: [],
      submittedDialog: false,
      addVehicleDialog: false,
      vehicleRegDialog: false,
      vehicleRegDialogData: {
        Reg: null,
        itemId: null
      },
      ctnSheetDialog: false,
      ctnSheetNote: '',
      attachedDocs: [],
      savingCtnSheet: false,
      qnq: '',
      customerPO: '',
      parentProducts: [],
      paymentMethods: [
        {text: 'Upfront Payment', value: 'upfront-payment'},
        {text: 'Upfront Installation', value: 'upfront-installation'},
        {text: 'Rental', value: 'rental'},
        {text: 'Lease', value: 'lease'}
      ],
      contractTerms: [
        {text: '30 Days', value: '30days'},
        {text: '60 Days', value: '60days'},
        {text: '90 Days', value: '90days'},
        {text: '6 Months', value: '6months'},
        {text: '9 Months', value: '9months'},
        {text: '12 Months', value: '12months'},
        {text: '18 Months', value: '18months'},
        {text: '24 Months', value: '24months'},
        {text: '36 Months', value: '36months'},
        {text: '48 Months', value: '48months'},
        {text: '60 Months', value: '60months'},
        {text: 'N/A', value: 'n/a'},
        {text: 'Demo', value: 'demo'}
      ],
      warranties: [
        {text: '30 Days', value: '30days'},
        {text: '60 Days', value: '60days'},
        {text: '90 Days', value: '90days'},
        {text: '6 Months', value: '6months'},
        {text: '9 Months', value: '9months'},
        {text: '12 Months', value: '12months'},
        {text: '18 Months', value: '18months'},
        {text: '24 Months', value: '24months'},
        {text: '36 Months', value: '36months'},
        {text: '48 Months', value: '48months'},
        {text: '60 Months', value: '60months'},
        {text: 'N/A', value: 'n/a'}
      ],
      warrantyType: [
        {text: 'Full', value: 'full'},
        {text: 'Parts', value: 'parts'},
        {text: 'Labour', value: 'labour'}
      ],
      currencies: [
        {text: '£', value: 'gbp'},
        {text: '€', value: 'euro'}
      ],
      rentalFrequencies: [
        {text: 'Monthly', value: 'monthly'},
        {text: 'Quarterly', value: 'quarterly'},
        {text: 'Annual', value: 'annual'}
      ],
      lessors: [
        {text: 'LDF (White Oak)', value: 'ldf'},
        {text: 'Lease Telecom', value: 'lease-telecom'},
        {text: 'Grenke', value: 'grenke'}
      ],
      leaseFrequencies: [
        {text: 'Monthly', value: 'monthly'},
        {text: 'Quarterly', value: 'quarterly'}
      ],
      finance: {}
    }
  },
  created () {
    this.$store.dispatch('fetchCustomers')
    this.getTemplates()
    this.getParentProducts()
  },
  watch: {
    customer (value) {
      if (value) {
        const index = this.customerList.findIndex(customerObj => {
          this.customerObj[customerObj.key] = {customerName: customerObj.name}
          return customerObj.key === value
        })
        this.customerShortName = this.customerList[index]['shortName']
      }
    }
  },
  filters: {
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    },
    formatBytes (bytes) {
      if (bytes == 0) return '0 Bytes'
      var k = 1024
      const dm = 2
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
  },
  methods: {
    selectNew () {
      this.vehicles = []
      for (const vehicle in this.vehicleList) {
        if (this.vehicleList.hasOwnProperty(vehicle)) {
          const element = this.vehicleList[vehicle]
          if (element.New) {
            this.vehicles.push(element)
          }
        }
      }
    },
    getTemplates () {
      fireStore.collection('productType').get()
      .then(snap => {
        let defaults = {}
        snap.forEach(doc => {
          if (doc.id !== '' && doc.data().hidden !== true) {
            let obj = doc.data()
            obj.id = doc.id
            obj.visible = true
            // obj.paymentMethods = []
            // obj.contractTerm = '36months'
            // obj.currency = 'gbp'
            // obj.upfrontPayment = null
            // obj.installationPayment = null
            // obj.rentalPayment = null
            // obj.rentalFrequency = null
            // obj.lessor = null
            // obj.leasePayment = null
            // obj.leaseFrequency = null
            // obj.warranty = null
            this.templates.push(obj)
            defaults[obj.id] = {}
            if (obj.extras) {
              obj.extras.forEach(extra => {
                defaults[obj.id][extra.name] = extra.default
              })
            }
          }
        })
        this.templates.sort((a, b) => {
          return a.Index - b.Index
        })
        this.templateDefaults = Object.assign({}, this.templateDefaults, defaults)
        this.allItems = Object.assign({}, this.allItems, defaults)
      })
    },
    getParentProducts () {
      fireStore.collection('parentProducts').orderBy('name').get()
      .then(snap => {
        snap.forEach(doc => {
          let data = {}
          data.value = doc.id
          data.text = doc.data().name
          this.parentProducts.push(data)
        })
      })
    },
    getVehicles () {
      this.gettingVehicles = true
      fireStore.collection('Vehicles').where('Customer', '==', this.customer).get()
      .then(snap => {
        snap.forEach(doc => {
          const data = doc.data()
          this.vehicleList.push(
            {
              id: doc.id,
              VehicleReg: data.VehicleReg,
              Make: data.Make,
              Model: data.Model,
              Year: data.Year,
              devices: data.devices,
              friendlyId: data.friendlyId,
              Added: data.Added,
              New: data.Added > (Date.now() - 86400000)
            }
          )
        })
        this.gettingVehicles = false
      })
    },
    deleteVehicle (item) {
      const index = this.vehicleList.findIndex(vehicle => {
        return item.id === vehicle.id
      })
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Vehicles').doc(item.id).delete().then(() => {
        updateAuditLog('delete', 'newOrder', this.user, null, null, 'deleted vehicle', item, item.Customer)
        this.vehicleList.splice(index, 1)
      })
    },
    step1 () {
      this.step = 1
      this.selectedTemplates = []
    },
    step2 () {
      if (this.step === 1) {
        this.vehicles = []
        this.vehicleList = []
        this.existingVehicleData = []
        this.newVehicleData = []
        this.getVehicles()
      }
      this.step = 2
    },
    step3 () {
      this.step = 3
    },
    step4 () {
      // Get vehicle data
      this.step = 4
      this.allItemsInstalledDevices = {}
      this.gettingVehicleData = true
      this.existingVehicleData = []
      this.newVehicleData = []
      // let vm = this
      let promises = this.vehicles.map(vehicle => {
        return new Promise((resolve, reject) => {
          fireStore.collection('Vehicles').doc(vehicle.id).get()
          .then(snap => {
            const obj = snap.data()
            obj.id = snap.id
            if (!obj.devices) {
              obj.devices = {}
              obj.installedDevices = {}
            } else {
              if (obj.devices.IGVjrrgemWhH8zki8yBZ && obj.devices.IGVjrrgemWhH8zki8yBZ && obj.devices.IGVjrrgemWhH8zki8yBZ['[Tacho Smart] VU Part Number'] && obj.devices.IGVjrrgemWhH8zki8yBZ['[Tacho Smart] VU Part Number'] === '' && obj.VUPartNo && obj.VUPartNo !== '') {
                obj.devices.IGVjrrgemWhH8zki8yBZ['[Tacho Smart] VU Part Number'] = obj.VUPartNo ? obj.VUPartNo : ''
              }
            }
            this.existingVehicleData.push(JSON.parse(JSON.stringify(obj)))
            this.newVehicleData.push(JSON.parse(JSON.stringify(obj)))

            resolve()
          })
        })
      })
      Promise.all(promises).then(() => {
        this.gettingVehicleData = false
      })
    },
    step4Back () {
      this.step = 4
    },
    step6 () {
      this.step = 6
      fireStore.collection('Sites').where('Customer', '==', this.customer).get()
      .then(snap => {
        this.sites = {}
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.sites[doc.id] = data
        })
      })
      fireStore.collection('Contacts').where('Customer', '==', this.customer).get()
      .then(snap => {
        this.contacts = []
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.contacts.push(data)
        })
      })
    },
    step5 () {
      this.step = 5
    },
    saveCtnSheetDialog () {
      this.ctnSheetNote = ''
      this.ctnSheetDialog = true
    },
    saveCtnSheet () {
      this.savingCtnSheet = true
      const refNo = this.customerShortName + moment().format('X')
      let promises = []
      let downloadUrls = []
      const storageRef = storage.ref('OrderDocs/' + refNo)
      this.attachedDocs.forEach((fileObj, index) => {
        promises.push(new Promise((resolve, reject) => {
          let uploadTask = storageRef.child(fileObj.file.name).put(fileObj.file)
          uploadTask.on('state_changed', snapshot => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.attachedDocs[index]['Progress'] = progress
            // switch (snapshot.state) {
            //   case storage.TaskState.PAUSED: // or 'paused'
            //     this.attachedDocs[index]['State'] = 2
            //     break
            //   case storage.TaskState.RUNNING: // or 'running'
            //     this.attachedDocs[index]['State'] = 1
            //     break
            // }
          }, error => {
            // Handle unsuccessful uploads
            this.attachedDocs[index]['State'] = 4
            reject(error)
          }, () => {
            // Handle successful uploads on complete
            this.attachedDocs[index]['Progress'] = 100
            this.attachedDocs[index]['State'] = 3
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              downloadUrls.push({downloadUrl: downloadURL, name: fileObj.file.name})
              resolve()
            })
          })
        })
        )
      })
      Promise.all(promises).then(async val => {
        const clean = (object) => {
          Object
            .entries(object)
            .forEach(([k, v]) => {
              if (v && typeof v === 'object') {
                clean(v)
              }
              if (v === undefined) {
                if (Array.isArray(object)) {
                  object.splice(k, 1)
                } else {
                  delete object[k]
                }
              }
            })
          return object
        }
        this.ctnSheetDialog = false
        let obj = {
          id: refNo,
          customer: this.customer,
          newVehicleData: this.newVehicleData,
          existingVehicleData: this.existingVehicleData,
          accepted: false,
          rejected: false,
          LastActionUser: this.username,
          LastActionDate: moment().format('YYYY-MM-DD HH:mm:ss'),
          selectedTemplates: this.selectedTemplates,
          note: this.ctnSheetNote ? this.ctnSheetNote + ' - ' + this.username : '',
          attachedDocs: downloadUrls,
          finance: this.finance,
          contacts: this.selectedContacts,
          qnq: this.qnq,
          customerPO: this.customerPO
        }
        obj = await clean(obj)
        fireStore.collection('CTN Sheets').add(obj)
        .then(docRef => {
          const customer = this.customerList.find(customerObj => {
            return customerObj.key === this.customer
          })
          updateAuditLog('add', 'newOrder', this.user, null, null, 'saved connection sheet', obj, this.customer)
          sendEmail('invoice@wearecubo.com',
                    `*ORDER* - (Cubo) - New Order Created - ${customer.name}`,
                    `-\n
                    Customer: ${customer.name}\n
                    Customer No: ${customer.shortName}\n
                    BDM: ${customer.BDM}\n
                    QNQ: ${this.qnq}\n
                    Customer PO: ${this.customerPO}`)
          fireStore.collection('CTNSheetsStatuses').add({key: docRef.id, id: refNo, customerName: customer.name, Status: 'Created', BDM: customer.BDM, BDMEmail: customer.BDMEmail})
          this.submittedRef = refNo
          this.submittedDialog = true
          this.savingCtnSheet = false
        })
        .catch(error => {
          console.log(error)
          this.savingCtnSheet = false
        })
      }).catch(error => {
        console.log(error)
        this.savingCtnSheet = false
      })
    },
    reset () {
      this.step = 1
      this.pagination = {
        sortBy: 'VehicleReg'
      }
      this.searchVehicles = ''
      this.searchVehicleData = ''
      this.customer = null
      this.customerShortName = null
      this.vehicles = []
      this.existingVehicleData = []
      this.newVehicleData = []
      this.vehicleList = []
      this.attachedDocs = []
      this.submittedRef = null
      this.submittedDialog = false
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    toggleGroup (templateId) {
      const index = this.selectedTemplates.findIndex(template => {
        return template.id === templateId
      })
      this.selectedTemplates[index]['visible'] = !this.selectedTemplates[index]['visible']
    },
    changeInstalledDevice (itemId, templateId) {
      const index = this.newVehicleData.findIndex(data => {
        return data.id === itemId
      })
      const existingIndex = this.existingVehicleData.findIndex(data => {
        return data.id === itemId
      })
      if (this.newVehicleData[index]['installedDevices'][templateId]) {
        if (this.existingVehicleData[existingIndex]['devices'][templateId]) {
          this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.existingVehicleData[existingIndex]['devices'][templateId])
        } else {
          this.$set(this.newVehicleData[index]['devices'], templateId, {})
          // this.newVehicleData[index]['devices'][templateId] = {}
          this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], this.templateDefaults[templateId])
          if (templateId === 'IGVjrrgemWhH8zki8yBZ') {
            this.newVehicleData[index]['devices'][templateId]['[Tacho Smart] VU Part Number'] = this.newVehicleData[index]['VUPartNo'] ? this.newVehicleData[index]['VUPartNo'] : ''
          }
        }
      } else {
        delete this.newVehicleData[index]['devices'][templateId]
        delete this.newVehicleData[index]['installedDevices'][templateId]
      }
    },
    newVehicleAdded (newVehicleData) {
      const obj = {
        devices: {},
        id: newVehicleData.id,
        Make: newVehicleData.Make,
        Model: newVehicleData.Model,
        Vehicle: newVehicleData.id,
        VehicleReg: newVehicleData.VehicleReg,
        Added: newVehicleData.Added,
        New: true,
        friendlyId: newVehicleData.friendlyId,
        Year: newVehicleData.Year
      }
      this.vehicleList.push(obj)
    },
    changeInstalledDeviceAll (templateId) {
      if (this.allItemsInstalledDevices[templateId]) {
        this.allItems[templateId] = {}
        const index = this.templates.findIndex(template => {
          return template.id === templateId
        })
        if (this.templates[index]['extras']) {
          this.templates[index].extras.forEach(extra => {
            // this.allItems[templateId][extra.name] = ''
            this.$set(this.allItems, templateId, {})
            this.allItems[templateId] = Object.assign({}, this.allItems[templateId], this.templateDefaults[templateId])
          })
        }
        this.newVehicleData.forEach((newVehicle, index) => {
          const existingIndex = index
          this.newVehicleData[index]['installedDevices'][templateId] = true
          if (this.existingVehicleData[existingIndex]['devices'][templateId]) {
            this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.existingVehicleData[existingIndex]['devices'][templateId])
          } else {
            this.$set(this.newVehicleData[index]['devices'], templateId, {})
            // this.newVehicleData[index]['devices'][templateId] = {}
            this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], this.templateDefaults[templateId])
            if (templateId === 'IGVjrrgemWhH8zki8yBZ') {
              this.newVehicleData[index]['devices'][templateId]['[Tacho Smart] VU Part Number'] = this.newVehicleData[index]['VUPartNo'] ? this.newVehicleData[index]['VUPartNo'] : ''
            }
          }
        })
      } else {
        this.newVehicleData.forEach((newVehicle, index) => {
          delete this.newVehicleData[index]['devices'][templateId]
          delete this.newVehicleData[index]['installedDevices'][templateId]
        })
      }
    },
    changeExtraAll (templateId, extraName) {
      const val = this.allItems[templateId][extraName]
      this.newVehicleData.forEach((newVehicle, index) => {
        let obj = this.newVehicleData[index]['devices'][templateId]
        obj[extraName] = val
        this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], obj)
      })
    },
    updateVehicleRegDialog (itemId) {
      const index = this.newVehicleData.findIndex(vehicle => {
        return vehicle.id === itemId
      })
      this.vehicleRegDialogData.Reg = this.newVehicleData[index]['VehicleReg']
      this.vehicleRegDialogData.itemId = itemId
      this.vehicleRegDialog = true
      this.$nextTick(this.$refs.updateVehicleRegInput.focus)
    },
    saveVehicleReg () {
      const newReg = this.vehicleRegDialogData.Reg.toUpperCase().replace(/\s/g, '')
      const vehId = this.vehicleRegDialogData.itemId
      const vehIndex = this.vehicleList.findIndex(vehicle => {
        return vehicle.id === vehId
      })
      if (this.vehicleList[vehIndex]['VehicleReg'] !== newReg) { // Only update firestore if reg has changed
        fireStore.collection('Vehicles').doc(vehId).update({VehicleReg: newReg})
        .then(ref => {
          const index = this.newVehicleData.findIndex(vehicle => {
            return vehicle.id === vehId
          })
          this.newVehicleData[index]['VehicleReg'] = newReg
          this.vehicleList[vehIndex]['VehicleReg'] = newReg
          this.vehicleRegDialogData.itemId = null
          this.vehicleRegDialogData.Reg = null
          this.vehicleRegDialog = false
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        this.vehicleRegDialogData.itemId = null
        this.vehicleRegDialogData.Reg = null
        this.vehicleRegDialog = false
      }
    },
    nextRow (rowIndex, extraName) {
      const nextIndex = parseInt(rowIndex) + 1
      if (nextIndex > this.newVehicleData.length - 1) {
        return
      }
      const ref = this.$refs['edit-' + extraName + '-' + nextIndex][0].$children[0].$refs.activator
      ref.click()
    },
    openEditDialog (rowIndex, extraName) {
      setTimeout(() => {
        const ref = this.$refs['input-' + extraName + '-' + rowIndex]
        this.$nextTick(ref[0].focus())
      }, 300)
    },
    vehiclesAdded (vehicleArr) {
      vehicleArr.forEach(vehicle => {
        vehicle.New = true
        vehicle.Added = Date.now()
        this.vehicleList.push(vehicle)
      })
    },
    attachFile (f) {
      if (f) {
        for (let docKey in this.attachedDocs) {
          if (this.attachedDocs[docKey].file.name === f.name) {
            console.log('file exists')
            alert('File with this name already exists. Either delete the existing file or rename the file you are trying to upload')
            return false
          }
        }
        this.attachedDocs.push({Progress: 0, State: 0, file: f})
      }
    },
    currencySymbolFromVal (val) {
      if (val) {
        const index = this.currencies.findIndex(currency => {
          return val === currency.value
        })
        return this.currencies[index]['text']
      }
      return null
    }
  },
  computed: {
    user () {
      return this.$store.getters.userName
    },
    customerList () {
      return this.$store.getters.customers
    },
    productsTreeView () {
      let products = []
      let templateObj = {}
      for (let i = 0; i < this.templates.length; i++) {
        const element = this.templates[i]
        if (templateObj[element.parent] !== undefined) {
          templateObj[element.parent].push({ id: element.id, name: element.name, child: true })
        } else {
          templateObj[element.parent] = [{ id: element.id, name: element.name, child: true }]
        }
        // products.push({
        //   id: i,
        //   name: element.text,
        //   children: [
        //     { id: 2, name: 'Calendar : app' },
        //     { id: 3, name: 'Chrome : app' },
        //     { id: 4, name: 'Webstorm : app' }
        //   ]
        // })
      }
      for (let i = 0; i < this.parentProducts.length; i++) {
        const element = this.parentProducts[i]
        products.push({
          id: i,
          name: element.text,
          children: templateObj[element.value] || []
        })
      }
      return products
    },
    vehicleDataHeaders () {
      let arr = []
      arr.push({
        align: 'left',
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        sortable: true
      })
      this.selectedTemplates.forEach(template => {
        let className = ['group-header']
        if (template.visible) {
          className.push('show')
        }
        let hasExtras = false
        let hasSalesExtra = false
        for (let key in template.extras) {
          if (template.extras[key].permissions.sales === 'write') {
            hasSalesExtra = true
            break
          }
        }
        if (template.extras) {
          hasExtras = true
        }
        arr.push({
          align: 'left',
          text: template.name,
          value: template.id,
          sortable: true,
          width: '50px',
          class: className,
          hasExtras: hasExtras && hasSalesExtra
        })
        if (template.extras && template.visible) {
          template.extras.forEach(templateExtra => {
            if (templateExtra.permissions.sales === 'write') {
              arr.push({
                text: templateExtra.name,
                value: templateExtra.name,
                sortable: true,
                class: 'col-' + template.id,
                align: 'left'
              })
            }
          })
        }
      })
      return arr
    },
    selectedTemplates () {
      let selectedTemplates = []
      this.finance = {}
      this.templates.forEach(template => {
        if (this.checkedTemplates.indexOf(template.id) !== -1) {
          this.$set(this.finance, template.id, {
            paymentMethods: [],
            contractTerm: '36months',
            currency: 'gbp',
            upfrontPayment: null,
            installationPayment: null,
            rentalPayment: null,
            rentalFrequency: null,
            lessor: null,
            leasePayment: null,
            leaseFrequency: null,
            warranty: null
          })
          selectedTemplates.push(template)
        }
      })
      return selectedTemplates
    }
  }
}
</script>
<style>
  .v-datatable thead th.column.sortable.active.desc i.group-hide-icon {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
.v-datatable thead th.column.sortable i.group-hide-icon {
    font-size: inherit;
    vertical-align: inherit;
    display: inherit;
    opacity: inherit;
    transition: inherit;
}

.v-table__overflow {
  max-height: 70vh; 
  overflow:auto;
}

.v-datatable thead th.column.group-header {
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// NewOrder.vue?9209da24